import { render } from "./About.vue?vue&type=template&id=08da8f66&scoped=true&ts=true"
import script from "./About.vue?vue&type=script&lang=ts"
export * from "./About.vue?vue&type=script&lang=ts"

import "./About.vue?vue&type=style&index=0&id=08da8f66&scoped=true&lang=less"

import exportComponent from "D:\\code\\hyz-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08da8f66"]])

export default __exports__